import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFormContext } from '@grandvisionhq/forms';
import { useSelector, useDispatch } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { ShippingObjectTypes } from '../../../state.js';
import { saveAddressLookup } from '../../../StepShipping/actions.js';
import { getDeliveryAddress, getBillingAddress } from '../../../StepShipping/selectors.js';
import { AddressLookup } from '../components/AddressLookup.js';
import { mapDataToFormValues } from '../utils/map-data-to-form-values.js';
import { validateInputField } from '../utils/validate-input-field.js';

const AddressLookupContainer = ({ errorMessage: initialErrorMessage1 , inputFieldName ='streetName' , label , maxLength , validations , validationsWithErrorMessages  })=>{
    const [isTouched, setIsTouched] = React.useState(false);
    const [errorMessage1, setErrorMessage] = React.useState(initialErrorMessage1);
    const deliveryAddress = useSelector(getDeliveryAddress);
    const billingAddress = useSelector(getBillingAddress);
    const { addressLookup  } = useCheckoutSettings();
    const { name , onChange , getInitialState  } = useFormContext();
    const currentForm = name === ShippingObjectTypes.BillingAddress ? billingAddress : deliveryAddress;
    const initialState1 = getInitialState && getInitialState(inputFieldName);
    const dispatch = useDispatch();
    const updateStore = React.useCallback((prefillData)=>{
        const dynamicForm = name === ShippingObjectTypes.BillingAddress ? {
            billingAddress: ShippingObjectTypes.BillingAddress
        } : {
            deliveryAddress: ShippingObjectTypes.DeliveryAddress
        };
        Object.entries(dynamicForm).forEach(([_, checkoutFormName])=>{
            dispatch(saveAddressLookup({
                formName: checkoutFormName,
                formData: {
                    streetName: (prefillData === null || prefillData === void 0 ? void 0 : prefillData.streetName) || '',
                    streetNumber: prefillData === null || prefillData === void 0 ? void 0 : prefillData.streetNumber,
                    city: prefillData === null || prefillData === void 0 ? void 0 : prefillData.city,
                    postalCode: prefillData === null || prefillData === void 0 ? void 0 : prefillData.postalCode,
                    region: prefillData === null || prefillData === void 0 ? void 0 : prefillData.region
                }
            }));
        });
    }, [
        dispatch,
        name
    ]);
    const validateInput = React.useCallback((value, initialErrorMessage = '')=>{
        const { isValid , errorMessage  } = validateInputField(true, value, initialErrorMessage, validations, validationsWithErrorMessages, maxLength);
        setErrorMessage(errorMessage);
        return isValid;
    }, [
        maxLength,
        validations,
        validationsWithErrorMessages
    ]);
    const updateForm = React.useCallback((value, initialRender)=>{
        onChange && onChange({
            name: inputFieldName,
            value,
            isTouched: initialRender ? !!(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched) : true,
            isValid: validateInput(value)
        });
    }, [
        onChange,
        inputFieldName,
        initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched,
        validateInput
    ]);
    const handleOnResult = React.useCallback((data)=>{
        const formattedData = mapDataToFormValues(data, addressLookup);
        const prefillData = swcHelpers.objectSpread({}, currentForm, formattedData);
        updateForm(prefillData.streetName);
        updateStore(prefillData);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentForm === null || currentForm === void 0 ? void 0 : currentForm.firstName,
        currentForm === null || currentForm === void 0 ? void 0 : currentForm.lastName
    ]);
    const handleIsTouched = React.useCallback(()=>{
        setIsTouched(true);
    }, []);
    const handleOnChange = React.useCallback((initialState)=>{
        if (onChange) {
            onChange({
                name: inputFieldName,
                value: initialState.value,
                isTouched: initialState.isTouched || isTouched || Boolean(initialState.value),
                isValid: validateInput(initialState.value, initialErrorMessage1)
            });
        }
    }, [
        initialErrorMessage1,
        inputFieldName,
        isTouched,
        onChange,
        validateInput
    ]);
    React.useEffect(()=>{
        if (!initialState1) {
            return;
        }
        handleOnChange(initialState1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched,
        initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.value,
        initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isValid
    ]);
    React.useEffect(()=>{
        // Initializing the field in form context so it can be prefilled.
        !(currentForm === null || currentForm === void 0 ? void 0 : currentForm.streetName) && updateForm('', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ React.createElement(AddressLookup, {
        hasDisplayError: !Boolean(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isValid) && (Boolean(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched) || isTouched),
        isDisplayIsValid: Boolean(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isValid) && (Boolean(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched) || isTouched),
        errorMessage: errorMessage1,
        inputFieldName: inputFieldName,
        label: label,
        setIsTouched: handleIsTouched,
        onResult: handleOnResult,
        streetName: (initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.value) || '',
        updateForm: updateForm
    });
};

export { AddressLookupContainer };
//# sourceMappingURL=AddressLookupContainer.js.map
